export enum PlansTabField {
  BillingOptions = 'billingOptions',
  BillingMonthlyEnabled = 'billingOptions.monthlyEnabled',
  BillingAnnualEnabled = 'billingOptions.annualEnabled',
  Plans = 'plans',
  Features = 'features',
  Options = 'options',
  OptionsShowFaq = 'options.showFaq',
  OptionsFaqQuestions = 'options.faqQuestions',
  OptionsShowSkipPriceSelection = 'options.showSkipPriceSelection',
  OptionsRequireTosBeforePlans = 'options.requireTosBeforePlans',
  OptionsSetupCheckoutText = 'options.setupCheckoutText',
  OptionsShowContactSupport = 'options.showContactSupport',
  OptionsContactSupportLink = 'options.contactSupportLink',
  OptionsTermsOfServiceUrl = 'options.termsOfServiceUrl',
  OptionsPrivacyPolicyUrl = 'options.privacyPolicyUrl',
  OptionsBrandingPrimaryColor = 'options.branding.primaryColor',
  OptionsBrandingSecondaryColor = 'options.branding.secondaryColor',
  OptionsBrandingBannerColor = 'options.branding.bannerColor',
  OptionsBrandingPageBlock1Color = 'options.branding.pageBlock1Color',
  OptionsBrandingBackgroundImageUrl = 'options.branding.backgroundImageUrl',
}

export interface PlansTabBrandingValues {
  primaryColor: string;
  secondaryColor: string;
  bannerColor: string;
  pageBlock1Color: string;
  backgroundImageUrl: string;
}

export interface PlansTabBillingOptionsValues {
  monthlyEnabled: boolean;
  annualEnabled: boolean;
}

export type PlanPlatformSlaValue = string | { id: string | number; label: string } | null;

export interface PlansTabPlanValues {
  id: string;
  name: string;
  enabled: boolean;
  mostPopular: boolean;
  callForPricing: boolean;
  monthlyPrice: string;
  annualPrice: string;
  sortOrder: number;
  platformSlaId?: PlanPlatformSlaValue;
}

export interface PlansTabFeatureValues {
  id: string;
  name: string;
  defaultContent: string;
  defaultTooltip: string;
  includedPlanIds: string[];
  overrideContentByPlanId: Record<string, string>;
  overrideTooltipByPlanId: Record<string, string>;
  sortOrder: number;
}

export interface PlansTabFaqQuestionValues {
  id: string;
  question: string;
  answer: string;
  sortOrder: number;
}

export interface PlansTabOptionsValues {
  showFaq: boolean;
  faqQuestions: PlansTabFaqQuestionValues[];
  showSkipPriceSelection: boolean;
  requireTosBeforePlans: boolean;
  setupCheckoutText: string;
  showContactSupport: boolean;
  contactSupportLink: string;
  termsOfServiceUrl: string;
  privacyPolicyUrl: string;
  branding: PlansTabBrandingValues;
}

export interface PlansTabFormValues {
  billingOptions: PlansTabBillingOptionsValues;
  plans: PlansTabPlanValues[];
  features: PlansTabFeatureValues[];
  options: PlansTabOptionsValues;
}

/** Resolved once in PlansTab and passed down; see the SLA field in PlanAccordion. */
export interface PlatformSlaFieldState {
  hasAccess: boolean;
  loading: boolean;
  options: { id: string; label: string }[];
}

export enum ExpandedSection {
  Billing = 'billing',
  Plans = 'plans',
  Features = 'features',
  Faq = 'faq',
  CtaSupport = 'cta-support',
}
